export default "__VITE_ASSET__LSBkTRQ$__"